'use client';

import { useState } from 'react';
import {
  getEditIndex,
  type ProfileListDialogState,
} from './business-profile.model';

const CLOSED_DIALOG: ProfileListDialogState = { kind: 'closed' };

export const useProfileListDialog = () => {
  const [state, setState] = useState<ProfileListDialogState>(CLOSED_DIALOG);

  return {
    isOpen: state.kind !== 'closed',
    isCreate: state.kind === 'create',
    editIndex: getEditIndex(state),
    openCreate: () => setState({ kind: 'create' }),
    openEdit: (index: number) => setState({ kind: 'edit', index }),
    close: () => setState(CLOSED_DIALOG),
  };
};
